import * as React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@fluentui/react-components";

const fadeIn = {
  from: {
    opacity: 0,
    transform: "translateY(10px)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0)",
  },
};

const useStyles = makeStyles({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    gap: 0,
  },
  title: {
    fontFamily: "Inter, sans-serif",
    fontSize: "2rem",
    fontWeight: 600,
    marginBottom: "3px",
    animationName: fadeIn,
    animationDuration: "0.5s",
    animationFillMode: "forwards",
  },
  subtitle: {
    fontFamily: "Inter, sans-serif",
    fontSize: "1.5rem",
    fontWeight: 400,
    marginTop: 0,
    marginBottom: "1em",
    opacity: 0,
    animationName: fadeIn,
    animationDuration: "0.5s",
    animationFillMode: "forwards",
    animationDelay: "0.2s",
  },
  content: {
    opacity: 0,
    animationName: fadeIn,
    animationDuration: "0.5s",
    animationFillMode: "forwards",
    animationDelay: "0.4s",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    flex: 1,
  },
});

const Slide = ({ title, subtitle, children }) => {
  const styles = useStyles();
  return (
    <div className={styles.root + " slide-root"}>
      <h1 className={styles.title}>{title}</h1>
      <h2 className={styles.subtitle}>{subtitle}</h2>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

Slide.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Slide;
